import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { paymentStatus } from "../lib/membership";
import { HALLOWEEN } from "../lib/events";
import { PartyPopper, Loader2, XCircle } from "lucide-react";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");

  useEffect(() => {
    if (cancelled || !sessionId) { if (!cancelled) setState("error"); return; }
    let tries = 0, timer;
    const poll = async () => {
      try {
        const s = await paymentStatus(sessionId);
        if (s.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(s.payment_status)) return setState("error");
      } catch (e) { /* retry */ }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, sessionId]);

  const view = {
    checking: { icon: <Loader2 className="w-14 h-14 text-[#00F0FF] mx-auto mb-3 animate-spin" />, title: "Confirming your payment…", text: "Hang on a second." },
    paid: { icon: <PartyPopper className="w-14 h-14 text-[#00FA9A] mx-auto mb-3" />, title: "Paid — you're booked in!", text: `See you at the ${HALLOWEEN.title}! ${HALLOWEEN.dj}, ${HALLOWEEN.timeLabel}. Your first drink is free. No alcohol.` },
    cancelled: { icon: <XCircle className="w-14 h-14 text-[#FF6B60] mx-auto mb-3" />, title: "Payment cancelled", text: "You haven't been charged and your ticket isn't booked. You can try again or choose to pay on arrival." },
    timeout: { icon: <Loader2 className="w-14 h-14 text-[#FFB800] mx-auto mb-3" />, title: "Still processing", text: "We couldn't confirm your payment yet. Check back shortly or message YAZ." },
    error: { icon: <XCircle className="w-14 h-14 text-[#FF6B60] mx-auto mb-3" />, title: "Payment not completed", text: "Your ticket isn't booked. Please try again." },
  }[state];

  return (
    <div data-testid="payment-result-page" className="min-h-screen bg-[#09090B] text-white flex items-center justify-center p-6">
      <div data-testid={`payment-${state}`} className="max-w-md w-full bg-[#18181B] border border-white/10 rounded-3xl p-8 text-center">
        {view.icon}
        <p data-testid="payment-result-title" className="font-display font-black text-3xl">{view.title}</p>
        <p className="text-white/80 mt-3">{view.text}</p>
        <Link data-testid="payment-back-home" to="/" className="inline-block mt-6 px-6 h-14 leading-[3.5rem] rounded-2xl bg-[#FF007F] font-display font-black">BACK TO YAZ</Link>
      </div>
    </div>
  );
}
